var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSignout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6h6v2.604c0 .5.5.5.5.5h1.1s.4 0 .4-.5V5c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-3.5c0-.5-.4-.5-.4-.5h-1.1s-.5 0-.5.5V18H6V6Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.534 12.999h6.243v1.697c0 .3.321.4.535.2L19.84 12.3c.213-.1.213-.4 0-.6l-3.528-2.596c-.214-.2-.535-.1-.535.2V11H9.534c-.32 0-.534.2-.534.5v.998c0 .3.214.5.534.5Z",
    fill: "#6E6E6E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSignout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Signout.744a0ac49d7dd8846ee5408f1efcd101.svg";